<div class="vehicle-switcher">
  <button
    class="vehicle-switcher-btn"
    [class.vehicle-switcher-btn--disabled]="filteredVehicles.length === 0"
    [title]="selectedVehicleObj?.name"
    (click)="toggle()"
    (keydown.enter)="toggle()"
  >
    <span class="vehicle-icon">
      <svg
        class="vehicle-icon-ring"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="12" r="11.75" stroke="#17648A" stroke-width="0.5" />
      </svg>
      <span class="vehicle-icon-inner"></span>
      <img class="vehicle-icon-img" [src]="iconExtension()" alt="vehicle" />
    </span>
    <span class="vehicle-name">{{ selectedVehicleObj?.name }}</span>
    <!-- Hide the chevron entirely when there's nothing to switch to -->
    <svg
      *ngIf="filteredVehicles.length > 0"
      class="chevron"
      [class.reverse]="isOpen"
      width="15"
      height="15"
    >
      <use
        [attr.xlink:href]="svgPath + 'sprite.svg#for-sidebar-arrow-down'"
      ></use>
    </svg>
  </button>

  <ul
    class="vehicle-switcher-list"
    *ngIf="isOpen && filteredVehicles.length > 0"
  >
    <li *ngFor="let vehicle of filteredVehicles">
      <button
        class="vehicle-switcher-item"
        (click)="selectVehicle(vehicle)"
        (keydown.enter)="selectVehicle(vehicle)"
      >
        <span class="vehicle-item-icon">
          <img [src]="svgPath + vehicle.icon" alt="vehicle" />
        </span>
        <span>{{ vehicle.name }}</span>
      </button>
    </li>
  </ul>
</div>
